import { AUTOPLAY_SELECTOR, isReadyGateClosed, playVideo } from './video-playback';

const VISIBILITY_THRESHOLD = 0.1;

export function initVideoVisibility() {
  const videoList = document.querySelectorAll(AUTOPLAY_SELECTOR);

  if (!videoList.length || !window.IntersectionObserver) {
    return;
  }

  const observer = new IntersectionObserver(
    (entryList) => {
      entryList.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          if (isReadyGateClosed(video)) {
            return;
          }

          playVideo(video);

          return;
        }

        video.pause();
      });
    },
    { threshold: VISIBILITY_THRESHOLD }
  );

  videoList.forEach((video) => observer.observe(video));
}
